const PATH = 'fe.components.learning_resources.search_results';

const messages = {
  results: {
    key: `${PATH}.results`,
    defaultValue: 'Results for'
  },
  noResults: {
    key: `${PATH}.no_results`,
    defaultValue: 'No Results'
  }
};

export default messages;
